import axios from 'axios'
import { ListResponse } from '../interfaces/Shipment/ListResponseDto'
import { DriversInterface } from '../interfaces'
const { REACT_APP_URL_PATH_API } = process.env

export const getDrivers = async (
  accountTypeID?: number,
  statusID?: number,
  identificationNumber?: string
): Promise<ListResponse<DriversInterface[]> | undefined> => {
  var response = await axios
    .post(`${REACT_APP_URL_PATH_API}/Account/GetAll`, {
      AccountTypeID: accountTypeID,
      StatusID: statusID,
      IdentificationNumber: identificationNumber,
    })
    .then(function (response) {
      var responsedto = response.data
      return responsedto as ListResponse<DriversInterface[]>
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.message ?? '')
        return error.response as ListResponse<DriversInterface[]>
      } else {
        console.log(error.message ?? '')
      }
      return [] as unknown as ListResponse<DriversInterface[]>
    })

  return response
}
